var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStarshipLaunchPills = function SvgStarshipLaunchPills(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 394,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#starship-launch-pills_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h1440v394H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__c)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 816,
    cy: 67.67,
    rx: 272,
    ry: 325.466,
    fill: "url(#starship-launch-pills_svg__d)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771.98-378.179c1.681 0 .149 32.745 36.546 32.745s37.093-32.393 37.093-32.393l-2.678 916.417c0 22.318-10.897 40.41-33.159 40.41s-33.809-18.092-33.809-40.41l-3.993-916.769Z",
    fill: "url(#starship-launch-pills_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M769.474-378.179c0-22.318 18.046-40.411 40.308-40.411s40.308 18.093 40.308 40.411l-7.149 916.769c0 22.318-10.897 40.41-33.159 40.41s-33.809-18.092-33.809-40.41l-6.499-916.769Z",
    fill: "url(#starship-launch-pills_svg__g)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__h)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__i)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1335.5,
    cy: 115.816,
    rx: 41.5,
    ry: 58.816,
    fill: "url(#starship-launch-pills_svg__j)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1316.83 89.915c0-11.38 8.36-20.607 18.68-20.607s18.68 9.226 18.68 20.607v229.478c0 11.381-8.36 20.607-18.68 20.607s-18.68-9.226-18.68-20.607V89.915Z",
    fill: "url(#starship-launch-pills_svg__k)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__l)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1206,
    cy: 594.412,
    rx: 198,
    ry: 236.588,
    fill: "url(#starship-launch-pills_svg__m)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__n)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1188.24,
    cy: 255.388,
    rx: 134.348,
    ry: 152.388,
    fill: "url(#starship-launch-pills_svg__o)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1159.12 191.12c1.71 0 0 33.459 37.06 33.459s40.37-33.459 40.37-33.459l-5.32 494.586c0 22.694-11.1 41.091-33.77 41.091s-34.42-18.397-34.42-41.091l-3.92-494.586Z",
    fill: "url(#starship-launch-pills_svg__q)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1156.42 191.283c0-22.694 18.37-41.091 41.04-41.091 22.67 0 41.05 18.397 41.05 41.091l-7.28 488.129c0 22.694-11.1 41.091-33.77 41.091s-34.42-18.397-34.42-41.091l-6.62-488.129Z",
    fill: "url(#starship-launch-pills_svg__r)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__s)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__t)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.387,
    cy: 358.785,
    rx: 91.677,
    ry: 103.785,
    fill: "url(#starship-launch-pills_svg__u)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__v)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 240,
    cy: 623.89,
    rx: 189,
    ry: 225.395,
    fill: "url(#starship-launch-pills_svg__w)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.412 315.126c1.168 0 .104 22.677 25.394 22.677s25.774-22.433 25.774-22.433l-1.861 634.645c0 15.456-7.572 27.985-23.04 27.985-15.469 0-23.492-12.529-23.492-27.985l-2.775-634.889Z",
    fill: "url(#starship-launch-pills_svg__y)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.671 315.126c0-15.456 12.54-27.985 28.008-27.985 15.469 0 28.009 12.529 28.009 27.985l-4.968 634.889c0 15.456-7.572 27.985-23.041 27.985-15.468 0-23.492-12.529-23.492-27.985l-4.516-634.889Z",
    fill: "url(#starship-launch-pills_svg__z)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__A)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 161,
    cy: 114.891,
    rx: 268,
    ry: 320.109,
    fill: "url(#starship-launch-pills_svg__B)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#starship-launch-pills_svg__C)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.547-430.772c2.316 0 0 45.271 50.164 45.271s54.643-45.271 54.643-45.271l-7.21 669.187c0 30.705-15.02 55.596-45.702 55.596s-46.597-24.891-46.597-55.596l-5.298-669.187Z",
    fill: "url(#starship-launch-pills_svg__D)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.887-430.552c0-30.705 24.873-55.596 55.555-55.596s55.555 24.891 55.555 55.596l-9.853 660.45c0 30.705-15.02 55.597-45.702 55.597s-46.597-24.892-46.597-55.597l-8.958-660.45Z",
    fill: "url(#starship-launch-pills_svg__E)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(93.98 376.437 414.434) scale(455.294 328.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A112FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A112FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 913.196 -132.372 0 809.826 -418.737)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#08C2ED",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#26A0F0",
    stopOpacity: 0.971
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#8433FC",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#A112FF",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A112FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90.565 605.786 201.322) scale(329.392 340.421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#81E0F5",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#08C2ED",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#17B1EF",
    stopOpacity: 0.871
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#3391F2",
    stopOpacity: 0.649
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#8433FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(93.362 613.144 687.583) scale(82.2207 50.0794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBEC",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#00CBEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.43114 214.98924 -81.81069 -.5446 1336.93 68.121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#8433FC",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#A112FF",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#A112FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(93.986 325.781 859.654) scale(330.965 238.766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A112FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A112FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-15.609 212.66093 -161.53147 -11.85618 1188.24 255.388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBEC",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#00CBEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 928.574 -134.79 0 1197.51 150.042)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#08C2ED",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#26A0F0",
    stopOpacity: 0.971
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#8433FC",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#A112FF",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A112FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-3.30925 334.92265 -346.62208 -3.42484 1200.82 166.605)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#81E0F5",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#08C2ED",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#17B1EF",
    stopOpacity: 0.871
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#3391F2",
    stopOpacity: 0.649
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#8433FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-10.65126 144.83488 -110.22434 -8.10597 229.387 358.785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBEC",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#00CBEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-21.95861 314.54345 -227.35765 -15.87208 240 623.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A112FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A112FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 632.414 -91.9788 0 235.709 287.038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#08C2ED",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#26A0F0",
    stopOpacity: 0.971
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#8433FC",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#A112FF",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A112FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.25817 228.10182 -236.53041 -2.34161 237.968 298.319)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#81E0F5",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#08C2ED",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#17B1EF",
    stopOpacity: 0.871
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#3391F2",
    stopOpacity: 0.649
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#8433FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__B",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(93.987 26.92 132.53) scale(447.803 323.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A112FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A112FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__D",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 1256.38 -182.443 0 149.503 -486.352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#08C2ED",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#26A0F0",
    stopOpacity: 0.971
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#8433FC",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#A112FF",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A112FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "starship-launch-pills_svg__E",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90.566 306.679 -155.737) scale(453.179 469.188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#81E0F5",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#08C2ED",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#17B1EF",
    stopOpacity: 0.871
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#3391F2",
    stopOpacity: 0.649
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#8433FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__b",
    x: 540,
    y: -469,
    width: 552,
    height: 1052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__c",
    x: 420,
    y: -381.796,
    width: 792,
    height: 898.933,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__e",
    x: 757.98,
    y: -392.179,
    width: 101.639,
    height: 985.179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__h",
    x: 1290,
    y: 53,
    width: 91,
    height: 291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__i",
    x: 1170,
    y: -67,
    width: 331,
    height: 365.632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__l",
    x: 884,
    y: 233.824,
    width: 644,
    height: 721.176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__n",
    x: 929.893,
    y: -21,
    width: 516.696,
    height: 552.776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__p",
    x: 1145.12,
    y: 177.12,
    width: 105.432,
    height: 563.677,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__s",
    x: 47,
    y: 251,
    width: 386,
    height: 731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__t",
    x: 13.71,
    y: 131,
    width: 431.354,
    height: 455.571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__v",
    x: -73,
    y: 274.495,
    width: 626,
    height: 698.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__x",
    x: 195.412,
    y: 301.126,
    width: 79.168,
    height: 690.874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__A",
    x: -231,
    y: -329.218,
    width: 784,
    height: 888.218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "starship-launch-pills_svg__C",
    x: 83.547,
    y: -444.772,
    width: 132.807,
    height: 752.783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_64_2095"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "starship-launch-pills_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1440v394H0z"
  })))));
};

export { SvgStarshipLaunchPills as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSIzOTQiIHZpZXdCb3g9IjAgMCAxNDQwIDM5NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzY0XzIwOTUpIj4KPHJlY3Qgd2lkdGg9IjE0NDAiIGhlaWdodD0iMzk0IiBmaWxsPSJibGFjayIvPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9mXzY0XzIwOTUpIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjFfZl82NF8yMDk1KSI+CjxlbGxpcHNlIGN4PSI4MTYiIGN5PSI2Ny42NzAzIiByeD0iMjcyIiByeT0iMzI1LjQ2NiIgZmlsbD0idXJsKCNwYWludDBfcmFkaWFsXzY0XzIwOTUpIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8L2c+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIyX2ZfNjRfMjA5NSkiPgo8cGF0aCBkPSJNNzcxLjk4IC0zNzguMTc5Qzc3My42NjEgLTM3OC4xNzkgNzcyLjEyOSAtMzQ1LjQzNCA4MDguNTI2IC0zNDUuNDM0Qzg0NC45MjMgLTM0NS40MzQgODQ1LjYxOSAtMzc3LjgyNyA4NDUuNjE5IC0zNzcuODI3TDg0Mi45NDEgNTM4LjU5Qzg0Mi45NDEgNTYwLjkwOCA4MzIuMDQ0IDU3OSA4MDkuNzgyIDU3OUM3ODcuNTIgNTc5IDc3NS45NzMgNTYwLjkwOCA3NzUuOTczIDUzOC41OUw3NzEuOTggLTM3OC4xNzlaIiBmaWxsPSJ1cmwoI3BhaW50MV9yYWRpYWxfNjRfMjA5NSkiLz4KPC9nPgo8cGF0aCBkPSJNNzY5LjQ3NCAtMzc4LjE3OUM3NjkuNDc0IC00MDAuNDk3IDc4Ny41MiAtNDE4LjU5IDgwOS43ODIgLTQxOC41OUM4MzIuMDQ0IC00MTguNTkgODUwLjA5IC00MDAuNDk3IDg1MC4wOSAtMzc4LjE3OUw4NDIuOTQxIDUzOC41OUM4NDIuOTQxIDU2MC45MDggODMyLjA0NCA1NzkgODA5Ljc4MiA1NzlDNzg3LjUyIDU3OSA3NzUuOTczIDU2MC45MDggNzc1Ljk3MyA1MzguNTlMNzY5LjQ3NCAtMzc4LjE3OVoiIGZpbGw9InVybCgjcGFpbnQyX3JhZGlhbF82NF8yMDk1KSIvPgo8L2c+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIzX2ZfNjRfMjA5NSkiPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyNF9mXzY0XzIwOTUpIj4KPGVsbGlwc2UgY3g9IjEzMzUuNSIgY3k9IjExNS44MTYiIHJ4PSI0MS41IiByeT0iNTguODE2MSIgZmlsbD0idXJsKCNwYWludDNfcmFkaWFsXzY0XzIwOTUpIiBmaWxsLW9wYWNpdHk9IjAuOCIvPgo8L2c+CjxwYXRoIGQ9Ik0xMzE2LjgzIDg5LjkxNDhDMTMxNi44MyA3OC41MzQyIDEzMjUuMTkgNjkuMzA4MyAxMzM1LjUxIDY5LjMwODNDMTM0NS44MyA2OS4zMDgzIDEzNTQuMTkgNzguNTM0MiAxMzU0LjE5IDg5LjkxNDhWMzE5LjM5M0MxMzU0LjE5IDMzMC43NzQgMTM0NS44MyAzNDAgMTMzNS41MSAzNDBDMTMyNS4xOSAzNDAgMTMxNi44MyAzMzAuNzc0IDEzMTYuODMgMzE5LjM5M1Y4OS45MTQ4WiIgZmlsbD0idXJsKCNwYWludDRfcmFkaWFsXzY0XzIwOTUpIi8+CjwvZz4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjVfZl82NF8yMDk1KSI+CjxlbGxpcHNlIGN4PSIxMjA2IiBjeT0iNTk0LjQxMiIgcng9IjE5OCIgcnk9IjIzNi41ODgiIGZpbGw9InVybCgjcGFpbnQ1X3JhZGlhbF82NF8yMDk1KSIgZmlsbC1vcGFjaXR5PSIwLjYiLz4KPC9nPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyNl9mXzY0XzIwOTUpIj4KPGVsbGlwc2UgY3g9IjExODguMjQiIGN5PSIyNTUuMzg4IiByeD0iMTM0LjM0OCIgcnk9IjE1Mi4zODgiIGZpbGw9InVybCgjcGFpbnQ2X3JhZGlhbF82NF8yMDk1KSIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9nPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyN19mXzY0XzIwOTUpIj4KPHBhdGggZD0iTTExNTkuMTIgMTkxLjEyQzExNjAuODMgMTkxLjEyIDExNTkuMTIgMjI0LjU3OSAxMTk2LjE4IDIyNC41NzlDMTIzMy4yNCAyMjQuNTc5IDEyMzYuNTUgMTkxLjEyIDEyMzYuNTUgMTkxLjEyTDEyMzEuMjMgNjg1LjcwNkMxMjMxLjIzIDcwOC40IDEyMjAuMTMgNzI2Ljc5NyAxMTk3LjQ2IDcyNi43OTdDMTE3NC43OSA3MjYuNzk3IDExNjMuMDQgNzA4LjQgMTE2My4wNCA2ODUuNzA2TDExNTkuMTIgMTkxLjEyWiIgZmlsbD0idXJsKCNwYWludDdfcmFkaWFsXzY0XzIwOTUpIi8+CjwvZz4KPHBhdGggZD0iTTExNTYuNDIgMTkxLjI4M0MxMTU2LjQyIDE2OC41ODkgMTE3NC43OSAxNTAuMTkyIDExOTcuNDYgMTUwLjE5MkMxMjIwLjEzIDE1MC4xOTIgMTIzOC41MSAxNjguNTg5IDEyMzguNTEgMTkxLjI4M0wxMjMxLjIzIDY3OS40MTJDMTIzMS4yMyA3MDIuMTA2IDEyMjAuMTMgNzIwLjUwMyAxMTk3LjQ2IDcyMC41MDNDMTE3NC43OSA3MjAuNTAzIDExNjMuMDQgNzAyLjEwNiAxMTYzLjA0IDY3OS40MTJMMTE1Ni40MiAxOTEuMjgzWiIgZmlsbD0idXJsKCNwYWludDhfcmFkaWFsXzY0XzIwOTUpIi8+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXI4X2ZfNjRfMjA5NSkiPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyOV9mXzY0XzIwOTUpIj4KPGVsbGlwc2UgY3g9IjIyOS4zODciIGN5PSIzNTguNzg1IiByeD0iOTEuNjc3NCIgcnk9IjEwMy43ODUiIGZpbGw9InVybCgjcGFpbnQ5X3JhZGlhbF82NF8yMDk1KSIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9nPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMTBfZl82NF8yMDk1KSI+CjxlbGxpcHNlIGN4PSIyNDAiIGN5PSI2MjMuODkiIHJ4PSIxODkiIHJ5PSIyMjUuMzk1IiBmaWxsPSJ1cmwoI3BhaW50MTBfcmFkaWFsXzY0XzIwOTUpIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8L2c+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIxMV9mXzY0XzIwOTUpIj4KPHBhdGggZD0iTTIwOS40MTIgMzE1LjEyNkMyMTAuNTggMzE1LjEyNiAyMDkuNTE2IDMzNy44MDMgMjM0LjgwNiAzMzcuODAzQzI2MC4wOTYgMzM3LjgwMyAyNjAuNTggMzE1LjM3IDI2MC41OCAzMTUuMzdMMjU4LjcxOSA5NTAuMDE1QzI1OC43MTkgOTY1LjQ3MSAyNTEuMTQ3IDk3OCAyMzUuNjc5IDk3OEMyMjAuMjEgOTc4IDIxMi4xODcgOTY1LjQ3MSAyMTIuMTg3IDk1MC4wMTVMMjA5LjQxMiAzMTUuMTI2WiIgZmlsbD0idXJsKCNwYWludDExX3JhZGlhbF82NF8yMDk1KSIvPgo8L2c+CjxwYXRoIGQ9Ik0yMDcuNjcxIDMxNS4xMjZDMjA3LjY3MSAyOTkuNjcgMjIwLjIxMSAyODcuMTQxIDIzNS42NzkgMjg3LjE0MUMyNTEuMTQ4IDI4Ny4xNDEgMjYzLjY4OCAyOTkuNjcgMjYzLjY4OCAzMTUuMTI2TDI1OC43MiA5NTAuMDE1QzI1OC43MiA5NjUuNDcxIDI1MS4xNDggOTc4IDIzNS42NzkgOTc4QzIyMC4yMTEgOTc4IDIxMi4xODcgOTY1LjQ3MSAyMTIuMTg3IDk1MC4wMTVMMjA3LjY3MSAzMTUuMTI2WiIgZmlsbD0idXJsKCNwYWludDEyX3JhZGlhbF82NF8yMDk1KSIvPgo8L2c+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIxMl9mXzY0XzIwOTUpIj4KPGVsbGlwc2UgY3g9IjE2MSIgY3k9IjExNC44OTEiIHJ4PSIyNjgiIHJ5PSIzMjAuMTA5IiBmaWxsPSJ1cmwoI3BhaW50MTNfcmFkaWFsXzY0XzIwOTUpIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8L2c+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIxM19mXzY0XzIwOTUpIj4KPHBhdGggZD0iTTk3LjU0NjkgLTQzMC43NzJDOTkuODYzMyAtNDMwLjc3MiA5Ny41NDY5IC0zODUuNTAxIDE0Ny43MTEgLTM4NS41MDFDMTk3Ljg3NSAtMzg1LjUwMSAyMDIuMzU0IC00MzAuNzcyIDIwMi4zNTQgLTQzMC43NzJMMTk1LjE0NCAyMzguNDE1QzE5NS4xNDQgMjY5LjEyIDE4MC4xMjQgMjk0LjAxMSAxNDkuNDQyIDI5NC4wMTFDMTE4Ljc2IDI5NC4wMTEgMTAyLjg0NSAyNjkuMTIgMTAyLjg0NSAyMzguNDE1TDk3LjU0NjkgLTQzMC43NzJaIiBmaWxsPSJ1cmwoI3BhaW50MTRfcmFkaWFsXzY0XzIwOTUpIi8+CjwvZz4KPHBhdGggZD0iTTkzLjg4NjcgLTQzMC41NTJDOTMuODg2NyAtNDYxLjI1NyAxMTguNzYgLTQ4Ni4xNDggMTQ5LjQ0MiAtNDg2LjE0OEMxODAuMTI0IC00ODYuMTQ4IDIwNC45OTcgLTQ2MS4yNTcgMjA0Ljk5NyAtNDMwLjU1MkwxOTUuMTQ0IDIyOS44OThDMTk1LjE0NCAyNjAuNjAzIDE4MC4xMjQgMjg1LjQ5NSAxNDkuNDQyIDI4NS40OTVDMTE4Ljc2IDI4NS40OTUgMTAyLjg0NSAyNjAuNjAzIDEwMi44NDUgMjI5Ljg5OEw5My44ODY3IC00MzAuNTUyWiIgZmlsbD0idXJsKCNwYWludDE1X3JhZGlhbF82NF8yMDk1KSIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2ZfNjRfMjA5NSIgeD0iNTQwIiB5PSItNDY5IiB3aWR0aD0iNTUyIiBoZWlnaHQ9IjEwNTIiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMiIgcmVzdWx0PSJlZmZlY3QxX2ZvcmVncm91bmRCbHVyXzY0XzIwOTUiLz4KPC9maWx0ZXI+CjxmaWx0ZXIgaWQ9ImZpbHRlcjFfZl82NF8yMDk1IiB4PSI0MjAiIHk9Ii0zODEuNzk2IiB3aWR0aD0iNzkyIiBoZWlnaHQ9Ijg5OC45MzMiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iNjIiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl82NF8yMDk1Ii8+CjwvZmlsdGVyPgo8ZmlsdGVyIGlkPSJmaWx0ZXIyX2ZfNjRfMjA5NSIgeD0iNzU3Ljk4IiB5PSItMzkyLjE3OSIgd2lkdGg9IjEwMS42MzkiIGhlaWdodD0iOTg1LjE3OSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSI3IiByZXN1bHQ9ImVmZmVjdDFfZm9yZWdyb3VuZEJsdXJfNjRfMjA5NSIvPgo8L2ZpbHRlcj4KPGZpbHRlciBpZD0iZmlsdGVyM19mXzY0XzIwOTUiIHg9IjEyOTAiIHk9IjUzIiB3aWR0aD0iOTEiIGhlaWdodD0iMjkxIiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjIiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl82NF8yMDk1Ii8+CjwvZmlsdGVyPgo8ZmlsdGVyIGlkPSJmaWx0ZXI0X2ZfNjRfMjA5NSIgeD0iMTE3MCIgeT0iLTY3IiB3aWR0aD0iMzMxIiBoZWlnaHQ9IjM2NS42MzIiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iNjIiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl82NF8yMDk1Ii8+CjwvZmlsdGVyPgo8ZmlsdGVyIGlkPSJmaWx0ZXI1X2ZfNjRfMjA5NSIgeD0iODg0IiB5PSIyMzMuODI0IiB3aWR0aD0iNjQ0IiBoZWlnaHQ9IjcyMS4xNzYiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iNjIiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl82NF8yMDk1Ii8+CjwvZmlsdGVyPgo8ZmlsdGVyIGlkPSJmaWx0ZXI2X2ZfNjRfMjA5NSIgeD0iOTI5Ljg5MyIgeT0iLTIxIiB3aWR0aD0iNTE2LjY5NiIgaGVpZ2h0PSI1NTIuNzc2IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjYyIiByZXN1bHQ9ImVmZmVjdDFfZm9yZWdyb3VuZEJsdXJfNjRfMjA5NSIvPgo8L2ZpbHRlcj4KPGZpbHRlciBpZD0iZmlsdGVyN19mXzY0XzIwOTUiIHg9IjExNDUuMTIiIHk9IjE3Ny4xMiIgd2lkdGg9IjEwNS40MzIiIGhlaWdodD0iNTYzLjY3NyIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSI3IiByZXN1bHQ9ImVmZmVjdDFfZm9yZWdyb3VuZEJsdXJfNjRfMjA5NSIvPgo8L2ZpbHRlcj4KPGZpbHRlciBpZD0iZmlsdGVyOF9mXzY0XzIwOTUiIHg9IjQ3IiB5PSIyNTEiIHdpZHRoPSIzODYiIGhlaWdodD0iNzMxIiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjIiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl82NF8yMDk1Ii8+CjwvZmlsdGVyPgo8ZmlsdGVyIGlkPSJmaWx0ZXI5X2ZfNjRfMjA5NSIgeD0iMTMuNzEiIHk9IjEzMSIgd2lkdGg9IjQzMS4zNTQiIGhlaWdodD0iNDU1LjU3MSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSI2MiIgcmVzdWx0PSJlZmZlY3QxX2ZvcmVncm91bmRCbHVyXzY0XzIwOTUiLz4KPC9maWx0ZXI+CjxmaWx0ZXIgaWQ9ImZpbHRlcjEwX2ZfNjRfMjA5NSIgeD0iLTczIiB5PSIyNzQuNDk1IiB3aWR0aD0iNjI2IiBoZWlnaHQ9IjY5OC43OSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSI2MiIgcmVzdWx0PSJlZmZlY3QxX2ZvcmVncm91bmRCbHVyXzY0XzIwOTUiLz4KPC9maWx0ZXI+CjxmaWx0ZXIgaWQ9ImZpbHRlcjExX2ZfNjRfMjA5NSIgeD0iMTk1LjQxMiIgeT0iMzAxLjEyNiIgd2lkdGg9Ijc5LjE2OCIgaGVpZ2h0PSI2OTAuODc0IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjciIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl82NF8yMDk1Ii8+CjwvZmlsdGVyPgo8ZmlsdGVyIGlkPSJmaWx0ZXIxMl9mXzY0XzIwOTUiIHg9Ii0yMzEiIHk9Ii0zMjkuMjE4IiB3aWR0aD0iNzg0IiBoZWlnaHQ9Ijg4OC4yMTgiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iNjIiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl82NF8yMDk1Ii8+CjwvZmlsdGVyPgo8ZmlsdGVyIGlkPSJmaWx0ZXIxM19mXzY0XzIwOTUiIHg9IjgzLjU0NjkiIHk9Ii00NDQuNzcyIiB3aWR0aD0iMTMyLjgwNyIgaGVpZ2h0PSI3NTIuNzgzIiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjciIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl82NF8yMDk1Ii8+CjwvZmlsdGVyPgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MF9yYWRpYWxfNjRfMjA5NSIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSg4MTYgNjcuNjcwMykgcm90YXRlKDkzLjk4MDEpIHNjYWxlKDQ1NS4yOTQgMzI4LjAwNCkiPgo8c3RvcCBzdG9wLWNvbG9yPSIjQTExMkZGIi8+CjxzdG9wIG9mZnNldD0iMC43MzA0NDMiIHN0b3AtY29sb3I9IiNBMTEyRkYiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MV9yYWRpYWxfNjRfMjA5NSIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSg4MDkuODI2IC00MTguNzM3KSByb3RhdGUoOTApIHNjYWxlKDkxMy4xOTYgMTMyLjM3MikiPgo8c3RvcCBvZmZzZXQ9IjAuMDQyMjg0MyIgc3RvcC1jb2xvcj0iIzA4QzJFRCIgc3RvcC1vcGFjaXR5PSIwLjk5NDE5Ii8+CjxzdG9wIG9mZnNldD0iMC4xNzU0OTUiIHN0b3AtY29sb3I9IiMyNkEwRjAiIHN0b3Atb3BhY2l0eT0iMC45NzE0MDciLz4KPHN0b3Agb2Zmc2V0PSIwLjMxOTM1OSIgc3RvcC1jb2xvcj0iIzg0MzNGQyIgc3RvcC1vcGFjaXR5PSIwLjkiLz4KPHN0b3Agb2Zmc2V0PSIwLjQzMDkxOSIgc3RvcC1jb2xvcj0iI0ExMTJGRiIgc3RvcC1vcGFjaXR5PSIwLjYyIi8+CjxzdG9wIG9mZnNldD0iMC41Nzk5NDQiIHN0b3AtY29sb3I9IiNBMTEyRkYiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50Ml9yYWRpYWxfNjRfMjA5NSIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSg4MTMuMDc1IC00MDIuNDQ4KSByb3RhdGUoOTAuNTY1Mykgc2NhbGUoMzI5LjM5MiAzNDAuNDIxKSI+CjxzdG9wIG9mZnNldD0iMC4wMTg2MyIgc3RvcC1jb2xvcj0iIzgxRTBGNSIgc3RvcC1vcGFjaXR5PSIwLjk5NDE5Ii8+CjxzdG9wIG9mZnNldD0iMC4xNzY2NDQiIHN0b3AtY29sb3I9IiMwOEMyRUQiIHN0b3Atb3BhY2l0eT0iMC45OTQxOSIvPgo8c3RvcCBvZmZzZXQ9IjAuMjcwNjM1IiBzdG9wLWNvbG9yPSIjMTdCMUVGIiBzdG9wLW9wYWNpdHk9IjAuODcxMDg4Ii8+CjxzdG9wIG9mZnNldD0iMC4zNTUwNDYiIHN0b3AtY29sb3I9IiMzMzkxRjIiIHN0b3Atb3BhY2l0eT0iMC42NDkyNjciLz4KPHN0b3Agb2Zmc2V0PSIwLjU1MzY5MiIgc3RvcC1jb2xvcj0iIzg0MzNGQyIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvcmFkaWFsR3JhZGllbnQ+CjxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnQzX3JhZGlhbF82NF8yMDk1IiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMzUuNSAxMTUuODE2KSByb3RhdGUoOTMuMzYxOSkgc2NhbGUoODIuMjIwNyA1MC4wNzk0KSI+CjxzdG9wIHN0b3AtY29sb3I9IiMwMENCRUMiIHN0b3Atb3BhY2l0eT0iMC42MyIvPgo8c3RvcCBvZmZzZXQ9IjAuNzMwNDQzIiBzdG9wLWNvbG9yPSIjMDBDQkVDIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9yYWRpYWxHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDRfcmFkaWFsXzY0XzIwOTUiIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMzNi45MyA2OC4xMjEyKSByb3RhdGUoOTAuMzgxNCkgc2NhbGUoMjE0Ljk5NCA4MS44MTI1KSI+CjxzdG9wIHN0b3AtY29sb3I9IiMwMENCRUMiLz4KPHN0b3Agb2Zmc2V0PSIwLjI3NTQwMSIgc3RvcC1jb2xvcj0iIzg0MzNGQyIgc3RvcC1vcGFjaXR5PSIwLjkiLz4KPHN0b3Agb2Zmc2V0PSIwLjUxNDI3NSIgc3RvcC1jb2xvcj0iI0ExMTJGRiIgc3RvcC1vcGFjaXR5PSIwLjYyIi8+CjxzdG9wIG9mZnNldD0iMC45NjIyMSIgc3RvcC1jb2xvcj0iI0ExMTJGRiIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvcmFkaWFsR3JhZGllbnQ+CjxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnQ1X3JhZGlhbF82NF8yMDk1IiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMDYgNTk0LjQxMikgcm90YXRlKDkzLjk4NTYpIHNjYWxlKDMzMC45NjUgMjM4Ljc2NikiPgo8c3RvcCBzdG9wLWNvbG9yPSIjQTExMkZGIi8+CjxzdG9wIG9mZnNldD0iMC43MzA0NDMiIHN0b3AtY29sb3I9IiNBMTEyRkYiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50Nl9yYWRpYWxfNjRfMjA5NSIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgxMTg4LjI0IDI1NS4zODgpIHJvdGF0ZSg5NC4xOTc5KSBzY2FsZSgyMTMuMjMzIDE2MS45NjYpIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzAwQ0JFQyIgc3RvcC1vcGFjaXR5PSIwLjYzIi8+CjxzdG9wIG9mZnNldD0iMC43MzA0NDMiIHN0b3AtY29sb3I9IiMwMENCRUMiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50N19yYWRpYWxfNjRfMjA5NSIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgxMTk3LjUxIDE1MC4wNDIpIHJvdGF0ZSg5MCkgc2NhbGUoOTI4LjU3NCAxMzQuNzkpIj4KPHN0b3Agb2Zmc2V0PSIwLjA0MjI4NDMiIHN0b3AtY29sb3I9IiMwOEMyRUQiIHN0b3Atb3BhY2l0eT0iMC45OTQxOSIvPgo8c3RvcCBvZmZzZXQ9IjAuMTc1NDk1IiBzdG9wLWNvbG9yPSIjMjZBMEYwIiBzdG9wLW9wYWNpdHk9IjAuOTcxNDA3Ii8+CjxzdG9wIG9mZnNldD0iMC4zMTkzNTkiIHN0b3AtY29sb3I9IiM4NDMzRkMiIHN0b3Atb3BhY2l0eT0iMC45Ii8+CjxzdG9wIG9mZnNldD0iMC40MzA5MTkiIHN0b3AtY29sb3I9IiNBMTEyRkYiIHN0b3Atb3BhY2l0eT0iMC42MiIvPgo8c3RvcCBvZmZzZXQ9IjAuNTc5OTQ0IiBzdG9wLWNvbG9yPSIjQTExMkZGIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9yYWRpYWxHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDhfcmFkaWFsXzY0XzIwOTUiIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIwMC44MiAxNjYuNjA1KSByb3RhdGUoOTAuNTY2MSkgc2NhbGUoMzM0LjkzOSAzNDYuNjM5KSI+CjxzdG9wIG9mZnNldD0iMC4wMTg2MyIgc3RvcC1jb2xvcj0iIzgxRTBGNSIgc3RvcC1vcGFjaXR5PSIwLjk5NDE5Ii8+CjxzdG9wIG9mZnNldD0iMC4xNzY2NDQiIHN0b3AtY29sb3I9IiMwOEMyRUQiIHN0b3Atb3BhY2l0eT0iMC45OTQxOSIvPgo8c3RvcCBvZmZzZXQ9IjAuMjcwNjM1IiBzdG9wLWNvbG9yPSIjMTdCMUVGIiBzdG9wLW9wYWNpdHk9IjAuODcxMDg4Ii8+CjxzdG9wIG9mZnNldD0iMC4zNTUwNDYiIHN0b3AtY29sb3I9IiMzMzkxRjIiIHN0b3Atb3BhY2l0eT0iMC42NDkyNjciLz4KPHN0b3Agb2Zmc2V0PSIwLjU1MzY5MiIgc3RvcC1jb2xvcj0iIzg0MzNGQyIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvcmFkaWFsR3JhZGllbnQ+CjxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnQ5X3JhZGlhbF82NF8yMDk1IiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDIyOS4zODcgMzU4Ljc4NSkgcm90YXRlKDk0LjIwNikgc2NhbGUoMTQ1LjIyNiAxMTAuNTIyKSI+CjxzdG9wIHN0b3AtY29sb3I9IiMwMENCRUMiIHN0b3Atb3BhY2l0eT0iMC42MyIvPgo8c3RvcCBvZmZzZXQ9IjAuNzMwNDQzIiBzdG9wLWNvbG9yPSIjMDBDQkVDIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9yYWRpYWxHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDEwX3JhZGlhbF82NF8yMDk1IiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDI0MCA2MjMuODkpIHJvdGF0ZSg5My45OTM0KSBzY2FsZSgzMTUuMzA5IDIyNy45MTEpIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0ExMTJGRiIvPgo8c3RvcCBvZmZzZXQ9IjAuNzMwNDQzIiBzdG9wLWNvbG9yPSIjQTExMkZGIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9yYWRpYWxHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDExX3JhZGlhbF82NF8yMDk1IiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDIzNS43MDkgMjg3LjAzOCkgcm90YXRlKDkwKSBzY2FsZSg2MzIuNDE0IDkxLjk3ODgpIj4KPHN0b3Agb2Zmc2V0PSIwLjA0MjI4NDMiIHN0b3AtY29sb3I9IiMwOEMyRUQiIHN0b3Atb3BhY2l0eT0iMC45OTQxOSIvPgo8c3RvcCBvZmZzZXQ9IjAuMTc1NDk1IiBzdG9wLWNvbG9yPSIjMjZBMEYwIiBzdG9wLW9wYWNpdHk9IjAuOTcxNDA3Ii8+CjxzdG9wIG9mZnNldD0iMC4zMTkzNTkiIHN0b3AtY29sb3I9IiM4NDMzRkMiIHN0b3Atb3BhY2l0eT0iMC45Ii8+CjxzdG9wIG9mZnNldD0iMC40MzA5MTkiIHN0b3AtY29sb3I9IiNBMTEyRkYiIHN0b3Atb3BhY2l0eT0iMC42MiIvPgo8c3RvcCBvZmZzZXQ9IjAuNTc5OTQ0IiBzdG9wLWNvbG9yPSIjQTExMkZGIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9yYWRpYWxHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDEyX3JhZGlhbF82NF8yMDk1IiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDIzNy45NjggMjk4LjMxOSkgcm90YXRlKDkwLjU2NzIpIHNjYWxlKDIyOC4xMTMgMjM2LjU0MikiPgo8c3RvcCBvZmZzZXQ9IjAuMDE4NjMiIHN0b3AtY29sb3I9IiM4MUUwRjUiIHN0b3Atb3BhY2l0eT0iMC45OTQxOSIvPgo8c3RvcCBvZmZzZXQ9IjAuMTc2NjQ0IiBzdG9wLWNvbG9yPSIjMDhDMkVEIiBzdG9wLW9wYWNpdHk9IjAuOTk0MTkiLz4KPHN0b3Agb2Zmc2V0PSIwLjI3MDYzNSIgc3RvcC1jb2xvcj0iIzE3QjFFRiIgc3RvcC1vcGFjaXR5PSIwLjg3MTA4OCIvPgo8c3RvcCBvZmZzZXQ9IjAuMzU1MDQ2IiBzdG9wLWNvbG9yPSIjMzM5MUYyIiBzdG9wLW9wYWNpdHk9IjAuNjQ5MjY3Ii8+CjxzdG9wIG9mZnNldD0iMC41NTM2OTIiIHN0b3AtY29sb3I9IiM4NDMzRkMiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MTNfcmFkaWFsXzY0XzIwOTUiIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYxIDExNC44OTEpIHJvdGF0ZSg5My45ODcxKSBzY2FsZSg0NDcuODAzIDMyMy4xNzgpIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0ExMTJGRiIvPgo8c3RvcCBvZmZzZXQ9IjAuNzMwNDQzIiBzdG9wLWNvbG9yPSIjQTExMkZGIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9yYWRpYWxHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDE0X3JhZGlhbF82NF8yMDk1IiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDE0OS41MDMgLTQ4Ni4zNTIpIHJvdGF0ZSg5MCkgc2NhbGUoMTI1Ni4zOCAxODIuNDQzKSI+CjxzdG9wIG9mZnNldD0iMC4wNDIyODQzIiBzdG9wLWNvbG9yPSIjMDhDMkVEIiBzdG9wLW9wYWNpdHk9IjAuOTk0MTkiLz4KPHN0b3Agb2Zmc2V0PSIwLjE3NTQ5NSIgc3RvcC1jb2xvcj0iIzI2QTBGMCIgc3RvcC1vcGFjaXR5PSIwLjk3MTQwNyIvPgo8c3RvcCBvZmZzZXQ9IjAuMzE5MzU5IiBzdG9wLWNvbG9yPSIjODQzM0ZDIiBzdG9wLW9wYWNpdHk9IjAuOSIvPgo8c3RvcCBvZmZzZXQ9IjAuNDMwOTE5IiBzdG9wLWNvbG9yPSIjQTExMkZGIiBzdG9wLW9wYWNpdHk9IjAuNjIiLz4KPHN0b3Agb2Zmc2V0PSIwLjU3OTk0NCIgc3RvcC1jb2xvcj0iI0ExMTJGRiIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvcmFkaWFsR3JhZGllbnQ+CjxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnQxNV9yYWRpYWxfNjRfMjA5NSIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgxNTMuOTgxIC00NjMuOTQpIHJvdGF0ZSg5MC41NjYzKSBzY2FsZSg0NTMuMTc5IDQ2OS4xODgpIj4KPHN0b3Agb2Zmc2V0PSIwLjAxODYzIiBzdG9wLWNvbG9yPSIjODFFMEY1IiBzdG9wLW9wYWNpdHk9IjAuOTk0MTkiLz4KPHN0b3Agb2Zmc2V0PSIwLjE3NjY0NCIgc3RvcC1jb2xvcj0iIzA4QzJFRCIgc3RvcC1vcGFjaXR5PSIwLjk5NDE5Ii8+CjxzdG9wIG9mZnNldD0iMC4yNzA2MzUiIHN0b3AtY29sb3I9IiMxN0IxRUYiIHN0b3Atb3BhY2l0eT0iMC44NzEwODgiLz4KPHN0b3Agb2Zmc2V0PSIwLjM1NTA0NiIgc3RvcC1jb2xvcj0iIzMzOTFGMiIgc3RvcC1vcGFjaXR5PSIwLjY0OTI2NyIvPgo8c3RvcCBvZmZzZXQ9IjAuNTUzNjkyIiBzdG9wLWNvbG9yPSIjODQzM0ZDIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9yYWRpYWxHcmFkaWVudD4KPGNsaXBQYXRoIGlkPSJjbGlwMF82NF8yMDk1Ij4KPHJlY3Qgd2lkdGg9IjE0NDAiIGhlaWdodD0iMzk0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";